import en from 'locales/en/recruiter/shell.json';

import { registerRecruiterNamespace } from '../registry';

export const SHELL_NS = registerRecruiterNamespace('shell', en);
